import { useEffect, useReducer } from "react";
import { useSearchParams } from "react-router-dom";
import { useTaskListContext } from "../../context/taskListContext";

export const useSearchParamsToReducer = ({
	searchData,
}: {
	searchData: Function;
}) => {
	const [shouldSearch, refetch] = useReducer((x) => x + 1, 0);
	const [searchParams, setSearchParams] = useSearchParams();

	const {
		state: { firstTime, assetSearchId },
		actions,
	} = useTaskListContext();

	useEffect(() => {
		let shouldUpdate = false;

		if (searchParams.has("type")) {
			const type = searchParams.get("type");
			if (type !== "A" && type !== "PM" && type !== "RM") {
				searchParams.delete("type");
				shouldUpdate = true;
			}
			actions.setTypeCode(type);
		}

		if (searchParams.has("craft")) {
			const craftsParam = searchParams.get("craft");
			if (craftsParam === "A") {
				actions.setCraftSearchId(["A"]);
			} else if (craftsParam) {
				const craftArray = craftsParam.split(",");
				const validCrafts = craftArray.filter((craft) => {
					if (craft === "A") return true;
					const craftNumber = Number.parseInt(craft);
					return !isNaN(craftNumber) && craftNumber >= 1;
				});

				if (validCrafts.length === 0) {
					searchParams.delete("craft");
					actions.setCraftSearchId(["A"]);
					shouldUpdate = true;
				} else {
					actions.setCraftSearchId(validCrafts);
				}
			} else {
				actions.setCraftSearchId(["A"]);
			}
		} else {
			actions.setCraftSearchId(["A"]);
		}

		if (searchParams.has("search")) {
			const search = searchParams.get("search");
			if (search === "") {
				searchParams.delete("search");
				shouldUpdate = true;
			}
			actions.setSearchText(search);
		} else {
			actions.setSearchText("");
		}

		if (searchParams.has("downHours")) {
			const downHours = searchParams.get("downHours");
			if (downHours === "") {
				searchParams.delete("downHours");
				shouldUpdate = true;
			}
			actions.setDownHours(downHours);
		} else {
			actions.setDownHours("");
		}

		if (shouldUpdate) {
			setSearchParams(searchParams, { replace: true });
		} else if (firstTime) {
			refetch();
			actions.setFirstTime(false);
		}
	}, [searchParams]);

	useEffect(() => {
		searchData();
	}, [shouldSearch, assetSearchId]);
};
